import { createHostModule } from '@wix/sdk-runtime/host-modules';
import { AdminHost, ItemSelectorSDK } from '../types';

export const itemSelector = createHostModule<AdminHost, ItemSelectorSDK>({
  openItemSelector:
    (host) =>
    (...args) => {
      if (!host.admin) {
        throw new Error(
          'admin is not available on the current host. Make sure to use an updated version of the host initialization package.',
        );
      }

      if (!host.admin.openItemSelector) {
        throw new Error(
          'openItemSelector is not available on the current host. Make sure to use an updated version of the host initialization package.',
        );
      }

      return host.admin.openItemSelector(...args);
    },
});
